import React, { useContext } from 'react';
import { VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';
import { formatNumber } from '../../../../../utils/methods';
import { TableContext } from '../../../../../contexts/TableContext';
import { RowClassName } from '../../../../../enums';
import { ViewMode } from './ViewModeToggle';

interface ZoneWiseRowItem {
  zone_code: string;
  zone_name: string;
  issued_qty: number;
  issued_qty_value: number;
  closing_qty: number;
  closing_qty_value: number;
}

interface ZoneWiseRowProps {
  item: ZoneWiseRowItem;
  className?: RowClassName;
  viewMode: ViewMode;
}

const ZoneWiseRow: React.FC<ZoneWiseRowProps> = ({ item, className, viewMode }) => {
  const { headCells } = useContext(TableContext);

  return (
    <tr className={className}>
      {headCells.map((headCell) => {
        if (headCell.id === VALIDATION_FIELD_MAPPING.zone) {
          return <td key={headCell.id} style={{ width: headCell.width }}>{item.zone_name}</td>;
        }

        if (headCell.id === VALIDATION_FIELD_MAPPING.secondary) {
          const val = viewMode === 'value' ? item.issued_qty_value : item.issued_qty;
          return <td key={headCell.id} style={{ width: headCell.width }}>{formatNumber(val)}</td>;
        }

        if (headCell.id === VALIDATION_FIELD_MAPPING.closing) {
          const val = viewMode === 'value' ? item.closing_qty_value : item.closing_qty;
          return <td key={headCell.id} style={{ width: headCell.width }}>{formatNumber(val)}</td>;
        }

        return <td key={headCell.id} />;
      })}
    </tr>
  );
};

export default ZoneWiseRow;
